import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectService } from '../../../services/project.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { ErrorMessagesService } from 'src/app/shared/messages/services/error-messages.service';

@Component({
  selector: 'app-atualizar-status-projeto',
  templateUrl: './atualizar-status-projeto.component.html',
  styleUrl: './atualizar-status-projeto.component.scss'
})
export class AtualizarStatusProjetoComponent implements OnInit {

  @Input() projetoId = '';
  @Input() statusAtual?: number;

  statusProjetoForm!: FormGroup
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private projectService: ProjectService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private errorMessagesService: ErrorMessagesService) { }

  ngOnInit(): void {
    this.statusProjetoForm = this.fb.group({
      projetoId: [this.projetoId],
      statusProjeto: [this.statusAtual, Validators.required]
    })
  }

  AtualizarDocumento(): void {

    if (!this.statusProjetoForm.valid) {
      this.statusProjetoForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;

    const documentoValies = this.statusProjetoForm.value;

    this.projectService.atualizarStatusProjeto(documentoValies.projetoId, parseInt(documentoValies.statusProjeto)).subscribe({
      next: (response) => {

        this.toastService.show("Status do projeto atualizado com sucesso!", {
          classname: "bg-success text-light",
        });

        this.activeModal.close();

        setTimeout(() => {
          let clienteId = this.route.snapshot.paramMap.get('id');

          if (clienteId) {
            this.router.navigate([`clientes/${clienteId}`], { queryParams: { extra: 2}});
            window.location.reload();
          }
        }, 500)
      },
      error: (error) => {
        let msg =  this.errorMessagesService.getMessage('ERR_0016');

        this.toastService.show(msg, {
          classname: "bg-danger text-light",
        });

        this.isLoading = false;
      }
    })
  }
}
